import { Colaborador } from "./colaborador";
import { Setor } from "./setor";
import { Turno } from "./turno";

export type RequestChange = {
  id: number;
  escalaId: number;
  data: string;
  dataTroca: string;
  requestType: CHANGE_REQUEST_TYPE;
  turno: {
    to: Turno | null;
    from: Turno | null;
  };
  setor: {
    to: Setor | null;
    from: Setor | null;
  };
  colaboradores: {
    to: Colaborador;
    from: Colaborador;
  }
  status: string;
}

export enum RequestType {
  PENDING = 'Pendente',
  ACCEPTED = 'Aceito e enviada RH'
}


export const CHANGE_REQUEST_TYPE_NAME = {
  0 :'Passe',
  1 :'Troca',
  2 :'Remanejamento',
}

export enum CHANGE_REQUEST_TYPE {
  PASSE = 0,
  TROCA = 1,
  REMANEJAMENTO = 2
}
